import React, { useState, useRef, useEffect } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import "./HomeBanner.css";
import video1 from "../Assets/Videos/BANNER 1_mixkit-man-and-woman-working-in-a-call-center-4658-hd-ready.mp4";
import video2 from "../Assets/Videos/BANNER 2_mixkit-clinic-staff-at-a-hospital-reception-4766-hd-ready.mp4";
import video3 from "../Assets/Videos/BANNER 3.mp4";

const HomeBanner = () => {
  const [currentVideo, setCurrentVideo] = useState(video1);
  const [currentText, setCurrentText] = useState({
    title: "Compassion in  Care & Excellence in Action",
    description:
      "Seamless RCM tools and seasoned experts' intervention ensure that every single provider under our umbrella care for their patients with ease and peace as the cash flows consistently to their accounts.",
  });

  const videoRef = useRef(null);

  const videoData = [
    {
      src: video1,
      title: "Compassion in  Care & Excellence in Action",
      description:
        "Seamless RCM tools and seasoned experts' intervention ensure that every single provider under our umbrella care for their patients with ease and peace as the cash flows consistently to their accounts.",
    },
    {
      src: video2,
      title: "Compassion in  Care & Excellence in Action",
      description:
        "Seamless RCM tools and seasoned experts' intervention ensure that every single provider under our umbrella care for their patients with ease and peace as the cash flows consistently to their accounts.",
    },
    {
      src: video3,
      title: "Compassion in  Care & Excellence in Action",
      description:
        "Seamless RCM tools and seasoned experts' intervention ensure that every single provider under our umbrella care for their patients with ease and peace as the cash flows consistently to their accounts.",
    },
  ];

  const handleVideoChange = (videoIndex) => {
    if (videoRef.current) {
      videoRef.current.pause(); // Pause before changing the source
      const selectedVideo = videoData[videoIndex];
      setCurrentVideo(selectedVideo.src);
      setCurrentText({
        title: selectedVideo.title,
        description: selectedVideo.description,
      });
    }
  };

  const handleVideoEnd = () => {
    const currentIndex = videoData.findIndex(
      (video) => video.src === currentVideo
    );
    const nextIndex = (currentIndex + 1) % videoData.length;
    handleVideoChange(nextIndex);
  };

  useEffect(() => {
    if (videoRef.current) {
      const videoElement = videoRef.current;
      const playVideo = () => {
        videoElement.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      };

      videoElement.load(); // Load the new video source
      videoElement.addEventListener("loadeddata", playVideo);

      return () => {
        videoElement.removeEventListener("loadeddata", playVideo);
      };
    }
  }, [currentVideo]);

  return (
    <div className="HomeBanner">
      <video
        ref={videoRef}
        className="HomeBanner-video"
        muted
        playsInline
        onEnded={handleVideoEnd}
      >
        <source src={currentVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="HomeBanner-overlay">
        <Container>
          <Row className="justify-content-start container-fluid maintitle">
            <Col
              lg={12}
              md={12}
              sm={12}
              className="mt-5 maintitle"
              style={{ marginTop: "250px" }}
            >
              <h1 className="HomeBanner-title maintitle">
                {currentText.title}
              </h1>
              <p className="HomeBanner-description maintitle">
                {currentText.description}
              </p>
            </Col>
          </Row>

          <Row className="justify-content-start mt-4 container-fluid">
            <Col lg={12} md={12} sm={12} style={{ textAlign: "center" }}>
              <Row>
                <Col lg={6} md={12} sm={12} style={{ textAlign: "end" }}>
                  <div className="HomeBanner-buttons formobilejourneybutton">
                    <Button
                      variant="outline-light"
                      size="lg"
                      className="HomeBanner-btn"
                    >
                      Join us on your journey
                    </Button>
                  </div>
                </Col>
                <Col lg={6} md={12} sm={12} style={{ textAlign: "start" }}>
                  <div className="HomeBanner-buttons ">
                    <span className="banner-last-text">
                      Let’s craft your{" "}
                      <strong style={{ fontSize: "20px" }}>
                        "Myrtle Moment"
                      </strong>{" "}
                      <br />
                      <span className="">
                        Not just a single chapter, but an ongoing story of
                        Excellence.
                      </span>
                    </span>
                  </div>
                </Col>
              </Row>

              {/* <div className="HomeBanner-dots">
                {videoData.map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${
                      currentVideo === videoData[index].src ? "active" : ""
                    }`}
                    onClick={() => handleVideoChange(index)}
                  ></span>
                ))}
              </div> */}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default HomeBanner;
